import { transformArrayToEntities } from '@app/shared/utils/static-helpers/array.utils';
import { createReducer, on } from '@ngrx/store';
import { clearState, errorPatientState, getOwners, getOwnersSuccess, getPatients, getPatientsSuccess } from './patient.actions';
import { initialPatientState } from './patient.state';

/**
 * Patient reducer
 */
export const patientReducer = createReducer(
  initialPatientState,
  on(getPatients, (state) => {
    return {
      ...state,
      patients: {},
      patientsLoading: true,
      patientsLoaded: false,
      error: null,
    };
  }),
  on(getPatientsSuccess, (state, { patients }) => ({
    ...state,
    patients: transformArrayToEntities(state.patients, patients),
    patientsLoading: false,
    patientsLoaded: true,
    error: null,
  })),
  on(getOwners, (state) => ({
    ...state,
    owners: {},
    ownersLoading: true,
    ownersLoaded: false,
    error: null,
  })),
  on(getOwnersSuccess, (state, { owners }) => ({
    ...state,
    owners: transformArrayToEntities(state.owners, owners),
    ownersLoading: false,
    ownersLoaded: true,
    error: null,
  })),
  on(errorPatientState, (_, { error }) => ({
    ...initialPatientState,
    error,
  })),
  on(clearState, () => initialPatientState),
);
